import { FC } from 'react'
import { Box, Stack, Typography } from '@mui/material'
import { useGetList, useTranslate } from 'react-admin'
import { ScheduleOut } from '../../types/apiRequests'
import { dateFormatter } from '../../utils/dateFormatter'
import ScheduleCancelButton from '../../components/buttons/ScheduleCancelButton'
import { border } from '../../layout/theme/border'
import { themeColor } from '../../layout/theme/color'

interface Props { certificateId?: string }

// Content only: the surrounding card and title come from CertificateForm.
const CertificateSchedules: FC<Props> = ({ certificateId }) => {
  const translate = useTranslate()

  const { data, isLoading, error } = useGetList<ScheduleOut>(
    'schedule',
    {
      filter: certificateId ? { certificateId: [certificateId] } : {},
      sort: { field: 'installationDatum', order: 'ASC' },
      pagination: { page: 1, perPage: 50 },
    },
    { enabled: !!certificateId }
  )

  if (!certificateId) return null

  return (
    <>
      {!isLoading && !error && (!data || data.length === 0) && (
        <Typography sx={{ fontSize: 13.5, color: themeColor.slate50 }}>
          {translate('resources.schedule.empty', { _: 'Geen geplande installaties.' })}
        </Typography>
      )}

      <Stack divider={<Box sx={{ borderTop: `${border.thin} solid ${border.light}` }} />}>
        {data?.map((s) => (
          <Stack
            key={s.id}
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            sx={{ 'py': 1.25, '&:first-of-type': { pt: 0 }, '&:last-of-type': { pb: 0 } }}
          >
            <Typography sx={{ fontSize: 13.5, color: themeColor.slate }}>
              {translate(`resources.schedule.status.${s.status}`, {
                date: dateFormatter(s.installationDatum),
              })}
            </Typography>

            <ScheduleCancelButton schedule={s} />
          </Stack>
        ))}
      </Stack>
    </>
  )
}

export default CertificateSchedules
